import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class MetricsManagementService {
  // 新增指标域
  static async createMetricsDmain(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/MetricsDmain', payload))
    return Callback(err, res)
  }
  // 搜索指标域（返回树结构）
  static async searchMetricsDmain(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/MetricsDmain/search', payload))
    return Callback(err, res)
  }
  // 根据父级id查询指标域
  static async getMetricsDmain(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/MetricsDmain?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 编辑指标域
  static async updateMetricsDmain(id, payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/MetricsDmain/${id}`, payload))
    return Callback(err, res)
  }
  // 删除指标域
  static async deleteMetricsDmain(id) {
    const [err, res] = await To(wizStandardInstance.delete(`/api/std/MetricsDmain/${id}`))
    return Callback(err, res)
  }
  // 指标分页接口
  static async getMetricsList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Metrics?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取指标创建人
  static async getMetricsUser(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Metrics/get-metrics-created-user-name', payload)
    )
    return Callback(err, res)
  }
  // 新增指标
  static async addMetrics(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Metrics', payload))
    return Callback(err, res)
  }
  // 查询维度列表
  static async queryDimensionList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/MetricsDataModel/query-dimension-list', payload)
    )
    return Callback(err, res)
  }
  // 查询指标详情
  static async getMetrics(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/Metrics/${payload}`))
    return Callback(err, res)
  }
  // 编辑指标
  static async updateMetrics(payload) {
    const [err, res] = await To(wizStandardInstance.put('/api/std/Metrics/update', payload))
    return Callback(err, res)
  }
  // 获取时间周期列表
  static async getTimeCycleList() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/Metrics/get-metrics-time-cycle-enum-list')
    )
    return Callback(err, res)
  }
  // 获取计算逻辑列表
  static async getLogicList() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/Metrics/get-metrics-logic-enum-list')
    )
    return Callback(err, res)
  }
  // 获取预览SQL
  static async getPreviewSql(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Metrics/get-preview-sql', payload)
    )
    return Callback(err, res)
  }
  // 开始计算
  static async startCompute(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Metrics/start-compute', payload))
    return Callback(err, res)
  }
  // 获取计算信息
  static async getComputeInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Metrics/get-compute-info?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取维度参考数据
  static async getDimensionReferenceData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/Metrics/get-dimension-reference-data?stdClassAttributeId=${payload}`
      )
    )
    return Callback(err, res)
  }
  // 获取指标维度列表
  static async queryMetricsDimensionList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Metrics/query-metrics-dimension-list', payload)
    )
    return Callback(err, res)
  }
  // 删除指标
  static async deleteMetrics(id) {
    const [err, res] = await To(wizStandardInstance.delete(`/api/std/Metrics/${id}`))
    return Callback(err, res)
  }
  // 修改指标发布状态
  static async updatePublish(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Metrics/update-publish', payload)
    )
    return Callback(err, res)
  }
  // 获取指标维度表名信息
  static async getMetricsTableNameInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Metrics/get-metrics-table-name-info', payload)
    )
    return Callback(err, res)
  }
  // 验证复合指标表达式
  static async verifySqlExpression(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Metrics/verify-sql-expression', payload)
    )
    return Callback(err, res)
  }
  // 查询指标数据表头
  static async queryMetricsDataHeader(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Metrics/query-metrics-data-header?id=${payload}`)
    )
    return Callback(err, res)
  }
  // 查询指标数据
  static async queryMetricsData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Metrics/query-metrics-data', payload)
    )
    return Callback(err, res)
  }
  // 是否存在依赖
  static async isExistDepend(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Metrics/is-exist-depend?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
